import React, { useState } from "react";
import { Form, Button, Alert, Modal } from "react-bootstrap";
import PrimarySidebar from "../PrimarySidebar/PrimarySidebar";
import Footer from '../Footer/Footer';

const RequestOwnershipForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "kiran@veritis.com",
    phoneNumber: "",
    businessName: "Veritis Group Inc",
    relationship: "",
    message: "",
    document: null,
    verificationCode: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [status, setStatus] = useState(null);
  const [codeSent, setCodeSent] = useState(false);
  const [showVerificationInput, setShowVerificationInput] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleChange = (e) => {
    if (e.target.name === "document") {
      setFormData({ ...formData, document: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setStatus({
      title: "Request Submitted Successfully!",
      message: "Your request to claim ownership has been received. We will verify the details and get back to you soon.",
      variant: "success",
    });
  };

  const handleSendVerificationCode = () => {
    setCodeSent(true);
    setShowVerificationInput(true);
    setTimeout(() => setCodeSent(false), 5000);
  };

  const handleResendCode = () => {
    setCodeSent(true);
    setTimeout(() => setCodeSent(false), 5000);
  };

  const handleVerifyOTP = () => {
    alert("OTP Verified!");
  };

  const handleDeleteRequest = () => {
    setSubmitted(false);
    setStatus(null);
    setShowDeleteModal(false);
    setFormData({
      name: "",
      email: "kiran@veritis.com",
      phoneNumber: "",
      businessName: "Veritis Group Inc",
      relationship: "",
      message: "",
      document: null,
      verificationCode: "",
    });
    setShowVerificationInput(false);
  };

  return (
    <div>
      <PrimarySidebar />
      <div className="js-pg-hg mt-5">
        <div className="container">

        <div className="heading mb-4 pb-1">
              <h4>Claim  This Page</h4>
            </div>
          <div className="row justify-content-center">
            <div className="col-lg-12">

              {!submitted && (
                <Form className="shadow-sm card p-5 rounded-4 m-auto" onSubmit={handleSubmit}>
                  <div className="heading d-flex justify-content-between">
                    <h4 className="mb-4">Request Ownership of Company Profile</h4>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-4">
                        <Form.Label>Business Name</Form.Label>
                        <Form.Control type="text" value={formData.businessName} disabled readOnly />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-4">
                        <Form.Label>Business Email Address</Form.Label>
                        <Form.Control type="email" value={formData.email} disabled readOnly />
                      </Form.Group>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-4">
                        <Form.Label>Contact Name</Form.Label>
                        <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} required />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-4">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control type="tel" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
                      </Form.Group>
                    </div>
                  </div>

                  <Form.Group className="mb-4">
                    <Form.Label>What is your relationship to the business?</Form.Label>
                    <Form.Select name="relationship" value={formData.relationship} onChange={handleChange} required>
                      <option value="">Select Relationship</option>
                      <option value="CEO">CEO</option>
                      <option value="Founder">Founder</option>
                      <option value="HR Manager">HR Manager</option>
                      <option value="Board Member">Board Member</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Message</Form.Label>
                    <Form.Control as="textarea" rows={3} name="message" value={formData.message} onChange={handleChange} />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Upload Document</Form.Label>
                    <Form.Control type="file" name="document" onChange={handleChange} accept=".pdf,.doc,.docx,.jpg,.png" />
                    <div className="form-text">Provide additional documents for company verification.</div>
                  </Form.Group>

                  {!showVerificationInput && (
                    <Button variant="outline-primary" className="text-primary py-2 resend_mx mt-2 mb-3" onClick={handleSendVerificationCode} disabled={codeSent}>
                      {codeSent ? "Code Sent!" : "Send Verification Code"}
                    </Button>
                  )}

                  {showVerificationInput && (
                    <Form.Group className="mb-4">
                      <Form.Label>Enter Your Verification Code</Form.Label>
                      <div className="d-flex align-items-center">

                        <Form.Control type="text" name="verificationCode" value={formData.verificationCode} onChange={handleChange} maxLength={5} required className="me-2" />
                        <Button variant="success" className="me-2 resend_bt" onClick={handleVerifyOTP}>Verify OTP</Button>
                        <Button variant="outline-secondary" className="text-primary resend_bt" onClick={handleResendCode} disabled={codeSent}>
                          {codeSent ? "Code Sent!" : "Resend Code"}
                        </Button>
                      </div>

                      <div className="form-text">Enter the 5-digit verification code sent to info@veritis.com.</div>
                    </Form.Group>
                  )}

                  <Button variant="primary" className="py-0 resend_mx mt-3 btn btn-lg" type="submit">Submit Request</Button>
                </Form>
              )}
                            {/* Show Status Card After Submission */}
                            {submitted && status && (
                <div className="card shadow-sm mt-4 p-4 py-5 rounded-4">
                  <div className="card-body text-center">
                  <i class='bx bxs-check-circle text-success display-2 mb-3' ></i>
                    <h5 className="card-title text-success">{status.title}</h5>
                    <p className="card-text">{status.message}</p>
                    <Button variant="outline-danger" onClick={() => setShowDeleteModal(true)}>Delete Request</Button>
                  </div>
                </div>
              )}

              {/* Delete Confirmation Modal */}
              <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Delete Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this request? This action cannot be undone.</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                  <Button variant="danger" onClick={handleDeleteRequest}>Delete</Button>
                </Modal.Footer>
              </Modal>

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RequestOwnershipForm;